import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Text, View } from 'react-native';
import { Interactable, Hr, Icon } from 'LocalGluons';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';
import sectionListStyles from '../../../localGluons/components/SectionList/SectionList.jss';

const styles = StyleSheet.create({
    innerItemContainer: {
        flexDirection: 'row'
    },
    iconContainer: {
        flex: 1,
        alignItems: 'flex-end',
        marginRight: '20%'
    },
    textContainer: {
        width: 'auto',
        maxWidth: '60%'
    },
    itemName: {
        flex: 2,
        fontFamily: Theme.regularFont,
        color: Device.isTabletOrWeb ? Theme.primaryTextColor : '#FFFFFF',
        fontSize: Theme.fontSizes.episodes,
        fontWeight: '100',
        marginVertical: 24,
        marginRight: 24,
        paddingLeft: 10
    }
});

const PlayListItem = ({ canPlay, title, onPress, onPlayPress, releaseDate }) => (
    <View>
        <Interactable style={sectionListStyles.innerItemContainer} onPress={onPress}>
            <View style={styles.textContainer}>
                <Text numberOfLines={1} style={styles.itemName}>
                    {title}
                </Text>
            </View>
            {releaseDate ? (
                <Text numberOfLines={1} style={sectionListStyles.itemName}>
                    {releaseDate}
                </Text>
            ) : null}
            <View style={styles.iconContainer}>
                {canPlay && <Icon name="play_circle" onPress={onPlayPress} />}
            </View>
            <Icon style={sectionListStyles.openIcon} name="arrow_right" />
        </Interactable>
        <Hr />
    </View>
);

PlayListItem.defaultProps = {
    canPlay: false,
    releaseDate: '',
    title: '',
    onPlayPress: () => {},
    onPress: () => {}
};

PlayListItem.propTypes = {
    canPlay: PropTypes.bool,
    title: PropTypes.string,
    onPress: PropTypes.func,
    onPlayPress: PropTypes.func,
    releaseDate: PropTypes.string
};

export default PlayListItem;
